var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "MountingPortal",
    {
      attrs: {
        mountTo: "#sidebar",
        append: "",
        name: "wiki_online_editing_users",
      },
    },
    [
      _c("SidebarWidget", {
        attrs: {
          title: _vm.$gettext("Anwesende Personen"),
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function fn() {
              return [
                _c(
                  "ol",
                  {
                    staticClass: "clean",
                  },
                  _vm._l(_vm.users, function (user) {
                    return _c(
                      "li",
                      {
                        key: user.user_id,
                      },
                      [
                        _c("img", {
                          staticClass: "avatar-small",
                          attrs: {
                            src: user.avatar,
                          },
                        }),
                        _vm._v(
                          "\n                    " +
                            _vm._s(user.fullname) +
                            "\n\n                    "
                        ),
                        user.editing
                          ? _c(
                              "span",
                              {
                                attrs: {
                                  title: _vm.$gettext(
                                    "Diese Person hat den Bearbeitungsmodus."
                                  ),
                                },
                              },
                              [
                                _c("studip-icon", {
                                  staticClass: "text-bottom",
                                  attrs: {
                                    shape: "comment",
                                    role: "info",
                                  },
                                }),
                              ],
                              1
                            )
                          : user.editing_request
                          ? _c(
                              "span",
                              {
                                attrs: {
                                  title: _vm.$gettext(
                                    "Diese Person beantragt den Bearbeitungsmodus."
                                  ),
                                },
                              },
                              [
                                _c("studip-icon", {
                                  staticClass: "text-bottom",
                                  attrs: {
                                    shape: "hand",
                                    role: "info",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }